"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
const core_1 = require("@babylonjs/core");
class Loader {
    static load(loadList, assetsHostUrl, scene) {
        return __awaiter(this, void 0, void 0, function* () {
            let resolve;
            let reject;
            let promise = new Promise((res, rej) => {
                resolve = res;
                reject = rej;
            });
            let models = new Array;
            let materialTypesOutput = new Array;
            let materialsOutput = new Array;
            let assetsManager = new core_1.AssetsManager(scene);
            //Meshes
            if (loadList.currentPoele != null) {
                const model = loadList.currentPoele.fileName + "_compressed.glb";
                assetsManager.addMeshTask("loadMeshesTask", "", assetsHostUrl + "Models/", model).onSuccess = (task) => {
                    task.loadedMeshes.forEach(mesh => {
                        models.push(mesh);
                    });
                };
            }
            //Material Type
            for (let i = 0; i < loadList.materialTypes.length; i++) {
                let type = loadList.materialTypes[i];
                assetsManager.addTextFileTask("loadMaterialTask", assetsHostUrl + type.url).onSuccess = (task => {
                    const nodeMaterial = core_1.NodeMaterial.Parse(JSON.parse(task.text), scene);
                    nodeMaterial.name = type.type + '_base';
                    let typeOutput = {
                        type: type.type,
                        material: nodeMaterial
                    };
                    materialTypesOutput.push(typeOutput);
                });
            }
            //Material
            for (let i = 0; i < loadList.materials.length; i++) {
                let mat = loadList.materials[i];
                let material = {
                    name: mat.name,
                    type: mat.type,
                    parameters: mat.parameters
                };
                for (let j = 0; j < mat.parameters.length; j++) {
                    let param = mat.parameters[j];
                    if (param.type == "texture") {
                        assetsManager.addTextureTask("load_Texture", assetsHostUrl + "Textures/" + param.value).onSuccess = (task => {
                            material.parameters[j].value = task.texture;
                        });
                    }
                    if (param.type == "env") {
                        assetsManager.addCubeTextureTask("load_CubeTexture", assetsHostUrl + param.value).onSuccess = (task => {
                            material.parameters[j].value = task.texture;
                        });
                    }
                }
                materialsOutput.push(material);
            }
            assetsManager.onFinish = (tasks) => {
                resolve([models, materialTypesOutput, materialsOutput]);
            };
            assetsManager.load();
            return promise;
        });
    }
}
exports.Loader = Loader;
//# sourceMappingURL=loader.js.map